import localforage from 'localforage'
import axios from 'axios'

export const homeOrders = {
    state: {
        homeOrders: null,
        loadingStatus: 'notLoading',
        buttonDisable: false
    },
    mutations: {
        SET_HOMEORDERS_LOADING_STATUS(state, status){
            state.loadingStatus = status
        },
        SET_HOMEORDERS(state, content) {
            state.homeOrders = content
        },
        SET_HOMEORDERS_BUTTON_DISABLE(state, status) {
            state.buttonDisable = status
        }
    },
    actions: {
        fetchHomeOrders({ state, commit, dispatch }, orderId) {
            // prevent multiple requests at same time
            if(state.loadingStatus === 'loading' || orderId === '')
                return
            commit('SET_HOMEORDERS_LOADING_STATUS', 'loading')
            return localforage.getItem('authUser').then((headers) => {
                return axios.get( process.env.VUE_APP_API+'baselinker_order/' + orderId, {headers: JSON.parse(headers) })
                .then((response) => {
                    if(response.data.data !== null && response.data.data.orders.length > 0) {
                        commit('SET_HOMEORDERS', Object.freeze(response.data.data))
                        commit('SET_HOMEORDERS_LOADING_STATUS', 'notLoading')
                        dispatch('setHomeOrdersButtonDisable', false)
                    } else {
                        commit('SET_HOMEORDERS', null)
                        commit('SET_HOMEORDERS_LOADING_STATUS', 'notFound')
                    }
                })
                .catch(error => {
                    commit('SET_HOMEORDERS', null)
                    commit('SET_HOMEORDERS_LOADING_STATUS', 'notLoading')
                    console.log(error);
                })
            })
        },
        baselinkerSet({ state, dispatch }, payload) {
            let endpoint = ''
            if(payload.delivered === true) {
                endpoint = process.env.VUE_APP_API+'baselinker_set_delivered/' + payload.id
            } else if(payload.delivered === false) {
                endpoint = process.env.VUE_APP_API+'baselinker_set_undelivered/' + payload.id
            } else {
                console.error('Modal error')
                return
            }
            const data = {}
            if(payload.textarea && payload.textarea !== '') {
                data['comment'] = payload.textarea
            }
            return localforage.getItem('authUser').then((headers) => {
                return axios.post( endpoint, data, {headers: JSON.parse(headers)})
                .then((response) => {
                    dispatch('setHomeOrdersButtonDisable', true)
                    dispatch('hideModal')
                }).catch(error => {
                    // load from local storage
                    console.log(error);
                    dispatch('setHomeOrdersButtonDisable', true)
                    dispatch('hideModal')
                })
            })
        },
        setHomeOrdersButtonDisable({ commit }, payload) {
            commit('SET_HOMEORDERS_BUTTON_DISABLE', payload)
        }
    },
    getters: {
        getHomeOrders: (state) => {
            if(state.homeOrders){
                return state.homeOrders
            }
        },
        getHomeOrdersLoadingStatus: (state) => {
            return state.loadingStatus
        },
        getHomeOrdersButtonDisable: (state) => {
            return state.buttonDisable
        },
    }
}
